export default function cover() {
  $(".wp-block-cover").each(function() {
    const $block = $(this);

    if ($block.text().trim() !== "") {
      $block.addClass("wp-block-cover--with-content");
    }
  });
}
